import React, { useState } from "react";
import "./MITMLab.css";

const MITM = () => {
  const [clientMsg, setClientMsg] = useState("");
  const [attackerMsg, setAttackerMsg] = useState("");
  const [serverResponse, setServerResponse] = useState("");

  const handleSend = () => {
    // Step 1: Client sends a message
    let originalMessage = clientMsg;

    // Step 2: Attacker intercepts and modifies
    let intercepted = clientMsg.replace(/password/gi, "*****");
    setAttackerMsg(intercepted);

    // Step 3: Server responds to modified request
    let response = intercepted.includes("*****")
      ? "⚠️ Server detected suspicious activity"
      : "✅ Server received: " + intercepted;

    setServerResponse(response);
  };

  return (
    <div className="mitm-container">
      <h2>🔗 MITM Attack Simulation</h2>

      <div className="mitm-flow">
        <div className="mitm-box client">
          <h3>Client</h3>
          <input
            type="text"
            placeholder="Type a message (e.g., password=1234)"
            value={clientMsg}
            onChange={(e) => setClientMsg(e.target.value)}
          />
          <button onClick={handleSend}>Send</button>
        </div>

        <div className="mitm-box attacker">
          <h3>👨‍💻 Attacker</h3>
          <p>{attackerMsg || "Waiting to intercept..."}</p>
        </div>

        <div className="mitm-box server">
          <h3>Server</h3>
          <p>{serverResponse || "No response yet"}</p>
        </div>
      </div>
    </div>
  );
};

export default MITM;
